export default (price: number | null): string | null => {
  if (!price) return null
  return `${price.toFixed(2)}€`
}
